import { connect } from 'react-redux';
import { IFavoriteButtonProps, FavoriteButton } from '../../components/FavoriteButton';
import { getIsFavorite } from '../../selectors/newbuilding';
import { getNewbuildingId } from '../../selectors/newbuilding/getNewduildingId';
import { getGALabel } from '../../selectors/newbuilding/getGALabel';
// oxlint-disable-next-line cian-eslint-compat/no-restricted-paths
import { addFavorite, removeFavorite } from '../../../browser/services/favorite';
import { TFavoriteEventSource } from '../../actions/analytics/trackFavorite';
import { TApplicationState, TDispatch } from '../../types/redux';

type TFavoriteButtonStateProps = Pick<
  IFavoriteButtonProps,
  'isFavorite' | 'newbuildingId' | 'gaLabel' | 'hideText' | 'isHeader' | 'buttonTheme'
>;

type TExternalFavoriteButtonProps = {
  isHeader?: boolean;
  buttonTheme?: IFavoriteButtonProps['buttonTheme'];
  source?: TFavoriteEventSource;
};

type TCompDispatchProps = Pick<IFavoriteButtonProps, 'actionAddFavorite' | 'actionRemoveFavorite'> &
  TFavoriteButtonStateProps;

interface IFavoriteButtonDispatchProps {
  dispatchAddFavorite(source?: TFavoriteEventSource): void;
  dispatchRemoveFavorite(source?: TFavoriteEventSource): void;
}

export function mapStateToProps(
  state: TApplicationState,
  ownProps: TExternalFavoriteButtonProps,
): TFavoriteButtonStateProps {
  return {
    isFavorite: getIsFavorite(state),
    isHeader: Boolean(ownProps.isHeader),
    hideText: Boolean(ownProps.isHeader),
    buttonTheme: ownProps.buttonTheme,
    newbuildingId: getNewbuildingId(state),
    gaLabel: getGALabel(state),
  };
}

export const mapDispatchToProps = (dispatch: TDispatch): IFavoriteButtonDispatchProps => {
  return {
    dispatchAddFavorite: source => {
      dispatch(addFavorite(source));
    },
    dispatchRemoveFavorite: source => {
      dispatch(removeFavorite(source));
    },
  };
};

export function mergeProps(
  stateProps: TFavoriteButtonStateProps,
  dispatchProps: IFavoriteButtonDispatchProps,
  ownProps: TExternalFavoriteButtonProps,
): TCompDispatchProps {
  return {
    actionAddFavorite: () => dispatchProps.dispatchAddFavorite(ownProps.source),
    actionRemoveFavorite: () => dispatchProps.dispatchRemoveFavorite(ownProps.source),
    ...stateProps,
  };
}

export const FavoriteButtonContainer = connect(mapStateToProps, mapDispatchToProps, mergeProps)(FavoriteButton);
